<template>
  <div id="app">
    <header class="console-topbar">
      <div class="brand-block">
        <img class="brand-logo" src="./assets/4.png" alt="SOULPOWER">
        <div class="brand-copy">
          <div class="brand-subtitle">SOULPOWERⅡ物料 · 喆喆Board · Made By Knox.Lai</div>
          <div class="brand-contact">小红书：Knox_5ai · 微信：Kanox5wbi3le</div>
        </div>
      </div>
      <div class="topbar-actions">
        <div class="language-switch">
          <button type="button" @click="changeLang('zh')" :class="['lang-button', $i18n.locale === 'zh' ? 'active' : '']">ZH</button>
          <button type="button" @click="changeLang('en')" :class="['lang-button', $i18n.locale === 'en' ? 'active' : '']">EN</button>
        </div>
        <el-popover placement="bottom-end" width="760" trigger="click">
          <div class="help-panel">
            <h2>{{ $t('index.helpTitle') }}</h2>
            <p>{{ $t('index.helpTips0') }}</p>
            <p>{{ $t('index.helpTips1') }}<br/>{{ $t('index.helpTips1_1') }}</p>
            <p>{{ $t('index.helpTips2') }}<br/>{{ $t('index.helpTips2_1') }}</p>
            <p>{{ $t('index.helpTips3') }}</p>
            <p>{{ $t('index.helpTips4') }}</p>
            <p>{{ $t('index.helpTips5') }}</p>
            <p>{{ $t('index.helpTips6') }}</p>
          </div>
          <el-button slot="reference" size="small" icon="el-icon-chat-dot-round">{{ $t('index.helpButton') }}</el-button>
        </el-popover>
      </div>
    </header>

    <main class="console-shell">
      <aside class="control-rail">
        <div class="device-card">
          <img class="device-preview" src="./assets/pcb.png" alt="3 Key board">
          <div class="device-meta">
            <span :class="['status-dot', sendLabel ? 'offline' : 'online']"></span>
            <span>{{ sendLabel ? $t('index.connFirst') : $t('index.disconnect') }}</span>
          </div>
          <el-button class="control-button" :type="conButtonType" @click="conClick()" icon="el-icon-cpu">{{ conButton }}</el-button>
          <el-button class="control-button" type="primary" @click="sendClick()" :disabled="sendLabel">{{sendText}}</el-button>
        </div>

        <section class="three-key-panel">
          <div class="section-kicker">Macro layer</div>
          <label class="switch-row">
            <span>{{ $t('index.keyAllLabel') }}</span>
            <el-switch v-model="keyallmodeshow" :active-text="$t('index.keyAllTrue')" :inactive-text="$t('index.keyAllFalse')"></el-switch>
          </label>
        </section>
        <section class="info-panel">
          <div class="section-kicker">GitHub</div>
          <a class="info-link" href="https://github.com/Knox-Lai" target="_blank" rel="noopener noreferrer">github.com/Knox-Lai</a>
        </section>
      </aside>

      <section class="config-deck">
        <div class="deck-header">
          <div>
            <h1>快捷键配置</h1>
          </div>
          <div class="deck-lines" aria-hidden="true"></div>
        </div>

        <div class="key-grid">
          <key-config ref="key1config" labelstr="key1" :stringshow="true"></key-config>
          <key-config ref="key2config" labelstr="key2" :stringshow="true"></key-config>
          <key-config ref="key3config" labelstr="key3" :stringshow="true"></key-config>
          <key-config v-show="keyallmodeshow" ref="keyallconfig" labelstr="keyAll" :stringshow="false"></key-config>
        </div>
      </section>
    </main>

    <footer class="console-footer">
      <div class="footer-info">
        <div class="footer-column footer-links">
          <span>{{ $t('index.keyTest') }}</span>
          <a href="https://keyboard.bmcx.com/" target="_blank">keyboard.bmcx.com</a>
          <span>{{ $t('index.mouseTest') }}</span>
          <a href="https://cps-check.com/cn/mouse-buttons-test" target="_blank">cps-check.com</a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import KeyConfig from './components/KeyConfig.vue';
import commonData from '../common.json';
export default {
  components: { KeyConfig },
  methods: {   
    conClick(){     
      if(this.sendLabel==false){
        this.sendLabel=true;
        this.sendText=this.$t('index.connFirst');
        this.conButton=this.$t('index.connButtonText1');
        this.conButtonType="primary";
        this.$refs.key1config.keyReset();
        this.$refs.key2config.keyReset();
        this.$refs.key3config.keyReset();
        this.$refs.keyallconfig.keyReset();
        this.keyallmodeshow=false;
        this.disconnectSerial();
      }
      else if (navigator.serial) {
		     this.connectSerial();
		   } else {
         alert(this.$t('index.browserErr'));
		   }
    },
    async sendCommit(){
      const data = new Uint8Array([0x02, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
                    0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
                    0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
                    0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
                    0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
                    0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0x00, 0x03 ]);
     let r1=this.$refs.key1config.getResult();
     if(!r1){
        return;
     }
     let r2=this.$refs.key2config.getResult();
     if(!r2){
        return;
     }
     let r3=this.$refs.key3config.getResult();
     if(!r3){
        return;
     }
     if(this.keyallmodeshow){
        let rall=this.$refs.keyallconfig.getResult();
        if(!rall){
            return;
        }
        data[115]=rall.keyCode;
        data[116]=rall.funcCode;
        data[117]=rall.mediaExtraCode;
        data[153]=0x01;
        for(var i=0;i<30;i++){
          data[118+i]=rall.stringCode[i];
        }
        for(var i=0;i<5;i++){
          data[148+i]=rall.mixCode[i];
        }
        if(this.oldversion){
          if(rall.funcCode==0x04 || rall.funcCode==0x05 ||rall.funcCode==0x06 ||rall.funcCode==0x07 ||rall.funcCode==0x08 ||rall.funcCode==0x09 ){
            this.$confirm(this.$t('index.firmwareErr'),  this.$t('index.tip'), {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: this.$t('index.updateHelp'),
                    cancelButtonText: this.$t('index.updateNo'),
                    type: 'warning'
                  }).then(() => {
                    this.$message({
                      type: 'success',
                      message: this.$t('index.redirecting')
                    });
                    window.location.href=this.$t('index.howtoaddress');
                  }).catch(() => {
                    return;
                  });
            return;
          }
        }
        if(this.v5version){
          if( (r1.funcCode==0x03&&r1.mediaExtraCode==0x01) || (r2.funcCode==0x03&&r2.mediaExtraCode==0x01) || (r3.funcCode==0x03&&r3.mediaExtraCode==0x01) ){
            this.$confirm(this.$t('index.firmwareErrv5'),  this.$t('index.tip'), {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: this.$t('index.updateHelp'),
                    cancelButtonText: this.$t('index.updateNo'),
                    type: 'warning'
                  }).then(() => {
                    this.$message({
                      type: 'success',
                      message: this.$t('index.redirecting')
                    });
                    window.location.href=this.$t('index.howtoaddress');
                  }).catch(() => {
                    return;
                  });
            return;
          }
        }
        if(!this.v7version){          
          if( (r1.funcCode==0x04&&r1.mediaExtraCode==0x02) || (r2.funcCode==0x04&&r2.mediaExtraCode==0x02) || (r3.funcCode==0x04&&r3.mediaExtraCode==0x02) || (rall.funcCode==0x04&&rall.mediaExtraCode==0x02) ){
            this.$confirm(this.$t('index.firmwareErrv6'),  this.$t('index.tip'), {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: this.$t('index.updateHelp'),
                    cancelButtonText: this.$t('index.updateNo'),
                    type: 'warning'
                  }).then(() => {
                    this.$message({
                      type: 'success',
                      message: this.$t('index.redirecting')
                    });
                    window.location.href=this.$t('index.howtoaddress');
                  }).catch(() => {
                    return;
                  });
            return;
          }
        }
     }
     if(this.oldversion){
      if(r1.funcCode==0x04 || r1.funcCode==0x05 ||r1.funcCode==0x06 ||r1.funcCode==0x07 ||r1.funcCode==0x08 ||r1.funcCode==0x09 ||
      r2.funcCode==0x04 || r2.funcCode==0x05 ||r2.funcCode==0x06 ||r2.funcCode==0x07 ||r2.funcCode==0x08 ||r2.funcCode==0x09 ||
      r3.funcCode==0x04 || r3.funcCode==0x05 ||r3.funcCode==0x06 ||r3.funcCode==0x07 ||r3.funcCode==0x08 ||r3.funcCode==0x09 ){
        this.$confirm(this.$t('index.firmwareErr'), this.$t('index.tip'), {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: this.$t('index.updateHelp'),
                    cancelButtonText: this.$t('index.updateNo'),
                    type: 'warning'
                  }).then(() => {
                    this.$message({
                      type: 'success',
                      message: this.$t('index.redirecting')
                    });
                    window.location.href=this.$t('index.howtoaddress');
                  }).catch(() => {
                    return;
                  });
            return;
      }      
     }
     data[1]=r1.keyCode;
     data[4]=r1.funcCode;
     data[7]=r1.mediaExtraCode;
     data[2]=r2.keyCode;
     data[5]=r2.funcCode;
     data[8]=r2.mediaExtraCode;
     data[3]=r3.keyCode;
     data[6]=r3.funcCode;
     data[9]=r3.mediaExtraCode;
     for(var i=0;i<30;i++){
      data[10+i]=r1.stringCode[i];
      data[40+i]=r2.stringCode[i];
      data[70+i]=r3.stringCode[i];
     }
     for(var i=0;i<5;i++){
      data[100+i]=r1.mixCode[i];
      data[105+i]=r2.mixCode[i];
      data[110+i]=r3.mixCode[i];
     }
      //console.log(data);
		  await this.writer.write(data);
    },
    async sendQuery(){
      const data = new Uint8Array([0x02,0x03]);
		  await this.writer.write(data);
    },
    sendClick(){
      this.sendCommit();
    },
    async connectSerial(){
          const filters = [
          { usbVendorId: 0x1209, usbProductId: 0xC550 }
        ];	   		      
		    try {
		      this.port = await navigator.serial.requestPort({ filters });
		      await this.port.open({ baudRate: 115200 });		      
			    this.writer = this.port.writable.getWriter();
			    const decoder = new TextDecoderStream();		
		      const readableStreamClosed = this.port.readable.pipeTo(decoder.writable);
          
		      const inputStream = decoder.readable;
          this.reader = decoder.readable.pipeThrough(new TransformStream(new LineBreakTransformer())).getReader();
		      this.sendLabel=false;
          this.sendText=this.$t('index.submit');
          this.conButton=this.$t('index.disconnect');
          this.conButtonType='warning';
          await this.sendQuery();
          let label=0;
		      while (true) {
		        const { value, done } = await this.reader.read();
               if(label==0){
                if(value=="1"){
                  this.$message({
                    message:this.$t('index.success'),
                    type:"success"
                  });
                  label=0;
                  continue;
                }else if(value && value!='v3' && value!='v4' && value!='v5' && value!='v6'&& value!='v7'){
                  await this.disconnectSerial();
                  this.sendLabel=true;
                  this.sendText=this.sendText=this.$t('index.submit');
                  this.conButton="this.$t('index.connButtonText1')";
                  this.conButtonType="primary";
                  this.$confirm(this.$t('index.firmwareErr1'),  this.$t('index.tip'), {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: this.$t('index.updateHelp'),
                    cancelButtonText: this.$t('index.updateNo1'),
                    type: 'warning'
                  }).then(() => {
                    this.$message({
                      type: 'success',
                      message: this.$t('index.redirecting')
                    });
                    window.location.href=this.$t('index.howtoaddress');
                  }).catch(() => {
                    this.$message({
                      type: 'success',
                      message: this.$t('index.redirecting')
                    });
                    window.location.href="https://topyuan.top/3keyold";
                  });
               
                  return;
                }else if(value=='v3' || value=='v4'){
                  this.oldversion = true;
                }else if(value=='v5'){
                  this.v5version = true;
                }else if(value=='v7'){
                  this.v7version = true;
                }
               }else if(label==1){
                this.key1=parseInt(value,16);
               }else if(label==2){
                this.key2=parseInt(value,16);             
               }else if(label==3){
                this.key3=parseInt(value,16);
               }else if(label==4){
                this.key1func=parseInt(value,16);
               }else if(label==5){
                this.key2func=parseInt(value,16);
               }else if(label==6){
                this.key3func=parseInt(value,16);
               }else if(label==7){
                this.key1f=parseInt(value,16);
               }else if(label==8){
                this.key2f=parseInt(value,16);
               }else if(label==9){
                this.key3f=parseInt(value,16);
               }else if(label==10){
                this.key1str=value;
               }else if(label==11){
                this.key2str=value;
               }else if(label==12){
                this.key3str=value;
               }else if(label==13){
                this.key1mix[0]=parseInt(value,16);
               }else if(label==14){
                this.key1mix[1]=parseInt(value,16);
               }else if(label==15){
                this.key1mix[2]=parseInt(value,16);
               }else if(label==16){
                this.key1mix[3]=parseInt(value,16);
               }else if(label==17){
                this.key1mix[4]=parseInt(value,16);
               }else if(label==18){
                this.key2mix[0]=parseInt(value,16);
               }else if(label==19){
                this.key2mix[1]=parseInt(value,16);
               }else if(label==20){
                this.key2mix[2]=parseInt(value,16);
               }else if(label==21){
                this.key2mix[3]=parseInt(value,16);
               }else if(label==22){
                this.key2mix[4]=parseInt(value,16);
               }else if(label==23){
                this.key3mix[0]=parseInt(value,16);
               }else if(label==24){
                this.key3mix[1]=parseInt(value,16);
               }else if(label==25){
                this.key3mix[2]=parseInt(value,16);
               }else if(label==26){
                this.key3mix[3]=parseInt(value,16);
               }else if(label==27){
                this.key3mix[4]=parseInt(value,16);
               }else if(label==28){
                this.keyall=parseInt(value,16);
               }else if(label==29){
                this.keyallfunc=parseInt(value,16);
               }else if(label==30){
                this.keyallf=parseInt(value,16);
               }else if(label==31){
                this.keyallstr=value;
               }else if(label==32){
                this.keyallmix[0]=parseInt(value,16);
               }else if(label==33){
                this.keyallmix[1]=parseInt(value,16);
               }else if(label==34){
                this.keyallmix[2]=parseInt(value,16);
               }else if(label==35){
                this.keyallmix[3]=parseInt(value,16);
               }else if(label==36){
                this.keyallmix[4]=parseInt(value,16);
               }else if(label==37){
                this.keyallmode=parseInt(value,16);
               }              
		        label++;
            if(label>=38){
              label=0;
              this.$refs.key1config.setKey(this.key1,this.key1func,this.key1f,this.key1str,this.key1mix);
              this.$refs.key2config.setKey(this.key2,this.key2func,this.key2f,this.key2str,this.key2mix);
              this.$refs.key3config.setKey(this.key3,this.key3func,this.key3f,this.key3str,this.key3mix);
              if(this.keyallmode==0x01){
                this.keyallmodeshow=true;
                this.$refs.keyallconfig.setKey(this.keyall,this.keyallfunc,this.keyallf,this.keyallstr,this.keyallmix);
              }else{
                this.keyallmodeshow=false;
              }
            }
		        if (done) {
              await readableStreamClosed.catch(()=>{});       
		          break;
		        }
		      }
		    } catch (error) {
          if(error.name=='NotFoundError'){
            return;
          }
          else if(error.name=='InvalidStateError'||error.name=='NetworkError'){
            this.$message.error(this.$t('index.conError1'));
          }
          else{
            this.$message.error(this.$t('index.conError2')+error);
          }
		    }
		  },
      async disconnectSerial(){	
        try{
        await this.reader.cancel(); 
        await this.reader.releaseLock();     
        await this.writer.close();
        await this.writer.releaseLock();
        await this.port.close();
        }catch(e){
          this.sendLabel=false;
          this.sendText=this.$t('index.submit');
          this.conButton=this.$t('index.disconnect');
          this.conButtonType='warning';
          // await this.sendQuery();
          this.$message.error(this.$t('index.conError3'));
          console.log(e);
        }
      },
      getCommonData(){
        var this_app=this;
        let commonkeys=[];
        for(var i=0;i<commonData.length;i++){
          let tmp={};
          if(!tmp.mixkeys){
            tmp.mixkeys=[];
          }
          for(var j=0;j<commonData[i].mixkeys.length;j++){
             tmp.mixkeys[j]=(parseInt(commonData[i].mixkeys[j]));
          }
          if(this_app.$i18n.locale=='zh'){
            tmp.description=commonData[i].description_zh;
          }else if(this_app.$i18n.locale=='en'){
            tmp.description=commonData[i].description_en;
          }
          commonkeys.push(tmp);          
        }
        this_app.$refs.key1config.setCommon(commonkeys);
        this_app.$refs.key2config.setCommon(commonkeys);
        this_app.$refs.key3config.setCommon(commonkeys);
        this_app.$refs.keyallconfig.setCommon(commonkeys);
      },
      changeLang(lang){        
        this.$i18n.locale = lang;
        localStorage.setItem('lang',lang);      
        this.$refs.key1config.refreshText();
        this.$refs.key2config.refreshText();
        this.$refs.key3config.refreshText();
        this.$refs.keyallconfig.refreshText();
        this.getCommonData();
        if(this.sendLabel==true){
          this.sendText=this.$t('index.connFirst');
          this.conButton=this.$t('index.connButtonText1');
        }else{
          this.sendText=this.$t('index.submit');
          this.conButton=this.$t('index.disconnect');
        }
      }
  },
  mounted (){
    this.getCommonData();    
  },
  data(){
    return{
      v5version:false,
      v7version:false,
      oldversion:false,
      keyallmodeshow:false,
      writer:{},
      port:{},
      reader:{},
      sendLabel:true,
      sendText:this.$t('index.connFirst'),
      conButton:this.$t('index.connButtonText1'),
      conButtonType:"primary",
      key1:0xff,
      key2:0xff,
      key3:0xff,
      key1func:0xff,
      key2func:0xff,
      key3func:0xff,
      key1f:0xff,
      key2f:0xff,
      key3f:0xff,
      key1str:'',
      key2str:'',
      key3str:'',
      key1mix:[0xff,0xff,0xff,0xff,0xff],
      key2mix:[0xff,0xff,0xff,0xff,0xff],
      key3mix:[0xff,0xff,0xff,0xff,0xff],
      keyall:0xff,
      keyallfunc:0xff,
      keyallf:0xff,
      keyallstr:'',
      keyallmix:[0xff,0xff,0xff,0xff,0xff],
      keyallmode:0xff
    }
  }
}
class LineBreakTransformer {
    constructor() {
        // Keep stream data until a complete line arrives.
        this.container = "";
    }

    transform(chunk, controller) {
        // Append the incoming chunk to the current buffer.
        this.container += chunk;
        // console.log(this.container);
        if(this.container=="1"){
          this.container="";
          controller.enqueue("1");          
        }
        else{
        // Emit every complete line after splitting by CRLF.
        const lines = this.container.split("\r\n");
        this.container = lines.pop();
        lines.forEach((line) => controller.enqueue(line));
        }
    }

    flush(controller) {
        // Flush the remaining buffered data.
        controller.enqueue(this.container);
    }
}
</script>

<style scoped>
#app {
  --ink: #000000;
  --muted: #565f64;
  --panel: #f4f6f6;
  --panel-strong: #ffffff;
  --line: #c8ccce;
  --line-dark: #565f64;
  --accent: #00a19b;
  --accent-dark: #007873;
  --danger: #565f64;
  --shadow: 0 18px 50px rgba(0, 0, 0, 0.1);
  min-height: 100vh;
  color: var(--ink);
  font-family: "Bahnschrift", "DIN Alternate", "Aptos", sans-serif;
  background:
    linear-gradient(90deg, rgba(86, 95, 100, 0.08) 1px, transparent 1px),
    linear-gradient(rgba(86, 95, 100, 0.08) 1px, transparent 1px),
    #eef1f1;
  background-size: 28px 28px;
}

.console-topbar {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 14px 26px;
  border-bottom: 1px solid rgba(47, 58, 66, 0.18);
  background: rgba(246, 247, 244, 0.92);
  backdrop-filter: blur(18px);
}

.brand-block,
.topbar-actions,
.language-switch,
.device-meta,
.switch-row {
  display: flex;
  align-items: center;
}

.brand-block {
  gap: 14px;
}

.brand-logo {
  width: 128px;
  height: 64px;
  object-fit: contain;
  flex: 0 0 128px;
}

.brand-subtitle,
.brand-contact,
.section-kicker,
.device-meta,
.footer-column,
.switch-row {
  color: var(--muted);
  font-size: 12px;
}

.brand-subtitle {
  color: #000000;
  font-size: 17px;
  font-weight: 800;
}

.brand-contact {
  margin-top: 3px;
  color: #000000;
  font-weight: 700;
  font-size: 14px;
}

.brand-copy {
  display: flex;
  flex-direction: column;
}

.topbar-actions {
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
}

.language-switch {
  padding: 3px;
  border: 1px solid var(--line);
  border-radius: 6px;
  background: var(--panel-strong);
}

.lang-button {
  min-width: 38px;
  height: 28px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: var(--muted);
  cursor: pointer;
  font-weight: 700;
}

.lang-button.active {
  background: #000000;
  color: #ffffff;
}

.console-shell {
  display: grid;
  grid-template-columns: minmax(260px, 320px) 1fr;
  gap: 22px;
  max-width: 1440px;
  margin: 0 auto;
  padding: 28px;
}

.control-rail {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.device-card,
.three-key-panel,
.info-panel,
.config-deck,
.console-footer {
  border: 1px solid rgba(47, 58, 66, 0.18);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.82);
  box-shadow: var(--shadow);
}

.device-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 18px;
}

.device-preview {
  display: block;
  width: 100%;
  max-height: 180px;
  object-fit: contain;
  border: 1px solid var(--line);
  border-radius: 6px;
  background: #ffffff;
}

.device-meta {
  width: 100%;
  justify-content: center;
  gap: 8px;
  min-height: 24px;
}

.status-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--danger);
  box-shadow: 0 0 0 4px rgba(214, 84, 69, 0.12);
}

.status-dot.online {
  background: var(--accent);
  box-shadow: 0 0 0 4px rgba(0, 161, 155, 0.14);
}

.control-button {
  width: 100%;
  font-family: Arial, sans-serif;
}

.device-card .control-button:nth-child(4) {
  margin-left: 12px;
  margin-right: 12px;
  width: calc(100% - 24px);
}

.device-card /deep/ .el-button--primary {
  border-color: var(--accent);
  background: var(--accent);
}

.device-card /deep/ .el-button--primary:hover,
.device-card /deep/ .el-button--primary:focus {
  border-color: var(--accent-dark);
  background: var(--accent-dark);
}

.device-card /deep/ .el-button.is-disabled,
.device-card /deep/ .el-button.is-disabled:hover,
.device-card /deep/ .el-button.is-disabled:focus {
  border-color: var(--line);
  background: #c8ccce;
  color: #ffffff;
}

.three-key-panel {
  padding: 18px;
}

.info-panel {
  padding: 18px;
}

.section-kicker {
  margin-bottom: 8px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.switch-row {
  justify-content: space-between;
  gap: 12px;
  line-height: 1.5;
}

.three-key-panel /deep/ .el-switch__label {
  color: var(--muted);
  font-weight: 700;
}

.three-key-panel /deep/ .el-switch__label.is-active {
  color: var(--accent-dark);
}

.info-link {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  color: var(--accent-dark);
  font-size: 13px;
  font-weight: 800;
  word-break: break-all;
}

.config-deck {
  padding: 22px;
}

.deck-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 18px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--line);
}

.deck-header h1 {
  margin: 0;
  font-size: 30px;
  line-height: 1;
}

.deck-lines {
  width: 170px;
  height: 34px;
  background:
    linear-gradient(90deg, var(--accent) 0 42%, transparent 42% 54%, var(--line-dark) 54% 100%),
    linear-gradient(90deg, var(--line-dark) 0 18%, transparent 18% 30%, #000000 30% 62%, transparent 62% 74%, var(--line-dark) 74% 100%);
  background-size: 100% 8px, 100% 8px;
  background-position: 0 4px, 0 22px;
  background-repeat: no-repeat;
}

.key-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.console-footer {
  display: block;
  max-width: 1440px;
  margin: 0 auto 28px;
  padding: 20px 28px;
}

.footer-info {
  display: grid;
  grid-template-columns: 1fr;
  gap: 18px;
}

.footer-column p {
  margin: 0 0 8px;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 18px;
}

.footer-links span {
  color: var(--muted);
  font-weight: 800;
}

.footer-links a {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 4px 10px;
  border: 1px solid var(--line);
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.72);
  font-weight: 800;
}

a {
  color: var(--accent-dark);
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.help-panel {
  color: var(--ink);
  font-family: "Bahnschrift", "DIN Alternate", "Aptos", sans-serif;
  line-height: 1.6;
}

.help-panel h2 {
  margin: 0 0 12px;
}

.help-panel p {
  margin: 0 0 10px;
}

@media (max-width: 980px) {
  .console-shell,
  .console-footer {
    grid-template-columns: 1fr;
  }

  .key-grid,
  .footer-info {
    grid-template-columns: 1fr;
  }

  .control-rail {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 640px) {
  .console-topbar,
  .console-shell,
  .console-footer {
    padding-left: 14px;
    padding-right: 14px;
  }

  .console-topbar,
  .deck-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .brand-block {
    align-items: flex-start;
  }

  .brand-contact {
    line-height: 1.4;
  }

  .control-rail {
    display: flex;
  }

  .deck-lines {
    width: 100%;
  }
}
</style>




// WEBPACK FOOTER //
// src/App.vue